import {
  GetOrderDetailBankpayment,
  GetOrderDetailData,
} from "services/interface";
import { formatDateWithTime } from "utils/dateFormat";
import { Typography, Image, Divider } from "antd";
import { FC } from "react";
import { numberFormat } from "utils/nuberFormat";
import noImage from "assets/images/no-image.png";
import { orderManualConfirm } from "config";

interface ConfirmPaymentPromptpayProps {
  item: GetOrderDetailBankpayment | undefined;
  paymentType: string;
  payment_point?: number;
  /** ยอด discount_amount ที่ต้องหักออกจากจำนวนเงิน (รับที่จุดขาย/ship shop) — หักเฉพาะรายการแรก */
  discountDeduct?: number;
}

const paymentTypeLabel = (type: string): string => {
  const map: Record<string, string> = {
    COD: "COD (เก็บเงินปลายทาง)",
    wallet_payment: "Wallet",
    manual_transfer: "โอนเงิน",
    promptpay: "พร้อมเพย์",
    credit_card: "บัตรเครดิต",
    truemoney: "TrueMoney",
    airpay: "AirPay",
    alipay: "Alipay",
  };
  return map[type] ?? type;
};

const ConfirmPaymentPromptpay: FC<ConfirmPaymentPromptpayProps> = ({
  item,
  paymentType,
  payment_point,
  discountDeduct = 0,
}) => {
  const displayPayAmount =
    item?.pay_amount != null ? item.pay_amount - discountDeduct : undefined;
  return (
    <>
      {item?.bank_id ? (
        <>
          <div style={{ display: "flex", flexDirection: "row", marginTop: 10 }}>
            <div style={{ flex: 1 }}>
              <Typography.Text style={{ fontWeight: "400" }}>
                โอนเข้าบัญชี
              </Typography.Text>
            </div>
            <div style={{ flex: 3 }}>
              {item?.bank_id ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {item?.bank_logo && (
                    <div style={{ flex: 1 }}>
                      <img
                        src={`${item?.bank_logo}`}
                        width={"100%"}
                        alt="bank_logo"
                      />
                    </div>
                  )}
                  <div
                    style={{
                      flex: 6,
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: 10,
                    }}
                  >
                    <Typography.Text>
                      {item?.bank_name ? `${item.bank_name}` : ""}
                    </Typography.Text>
                    <Typography.Text>
                      {item?.account_no ? `เลขบัญชี ${item.account_no}` : ""}
                    </Typography.Text>
                    <Typography.Text>
                      {item?.account_name
                        ? `ชื่อบัญชี ${item.account_name}`
                        : ""}
                    </Typography.Text>
                  </div>
                </div>
              ) : (
                <Typography.Text>ไม่ได้ระบุ</Typography.Text>
              )}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
              <Typography.Text style={{ fontWeight: "400" }}>
                ยอดโอน
              </Typography.Text>
            </div>
            <div style={{ flex: 3 }}>
              <Typography.Text>
                {(displayPayAmount != null &&
                  numberFormat(displayPayAmount) + ` บาท`) ||
                  "ไม่ได้ระบุ"}
              </Typography.Text>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
              <Typography.Text style={{ fontWeight: "400" }}>
                วันเวลาที่โอน
              </Typography.Text>
            </div>
            <div style={{ flex: 3 }}>
              {item?.payment_date ? (
                <Typography.Text>
                  {item?.payment_date && formatDateWithTime(item?.payment_date)}
                </Typography.Text>
              ) : (
                <Typography.Text>ไม่ได้ระบุ</Typography.Text>
              )}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1 }}>
              <Typography.Text style={{ fontWeight: "400" }}>
                สลิป
              </Typography.Text>
            </div>
            {item?.image_slip && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Image width={180} src={`${item?.image_slip ?? noImage}`} />
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          {/* <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 2 }}>
                    <Typography.Text>
                        ชำระเงินผ่านช่องทางอัตโนมัติ
                    </Typography.Text>
                    
                </div>
            </div> */}
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
              <Typography.Text style={{ fontWeight: "400" }}>
                ช่องทาง
              </Typography.Text>
            </div>
            <div style={{ flex: 3 }}>
              <Typography.Text>{paymentTypeLabel(paymentType) || "ไม่ได้ระบุ"}</Typography.Text>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
              <Typography.Text style={{ fontWeight: "400" }}>
                จำนวนเงิน
              </Typography.Text>
            </div>
            <div style={{ flex: 3 }}>
              <Typography.Text>
                {(displayPayAmount != null &&
                  numberFormat(displayPayAmount) + ` บาท`) ||
                  "ไม่ได้ระบุ"}
              </Typography.Text>
            </div>
          </div>
          {payment_point ?? 0 > 0 ? (
            <>
              <div
                style={{ display: "flex", flexDirection: "row", marginTop: 10 }}
              >
                <div style={{ flex: 1 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    ช่องทาง
                  </Typography.Text>
                </div>
                <div style={{ flex: 3 }}>
                  <Typography.Text>{"ชำระด้วย Point"}</Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 1 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    จำนวน Point
                  </Typography.Text>
                </div>
                <div style={{ flex: 3 }}>
                  <Typography.Text>
                    {(payment_point &&
                      numberFormat(payment_point) + ` point`) ||
                      "0"}
                  </Typography.Text>
                </div>
              </div>
            </>
          ) : null}
          {/* <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 1 }}>
                <Typography.Text style={{ fontWeight: "400" }}>
                    วันเวลาที่โอน
                </Typography.Text>
                </div>
                <div style={{ flex: 3 }}>
                    <Typography.Text>
                        {item?.payment_date && formatDateWithTime(item?.payment_date)}
                    </Typography.Text>
                </div>
            </div> */}
        </>
      )}
    </>
  );
};

export default ConfirmPaymentPromptpay;
